import { type GetServerSidePropsContext } from 'next'

import {
  type AuthBackendUpstreamVariant,
  AUTH_BACKEND_UPSTREAM_COOKIE,
  AUTH_BACKEND_UPSTREAM_VARIANTS,
} from './constants'

const VALID = new Set<string>(Object.values(AUTH_BACKEND_UPSTREAM_VARIANTS))

export function readAuthBackendUpstreamCookie(
  ctx: GetServerSidePropsContext
): AuthBackendUpstreamVariant | null {
  const value = ctx.req.cookies?.[AUTH_BACKEND_UPSTREAM_COOKIE]
  if (value && VALID.has(value)) return value as AuthBackendUpstreamVariant
  return null
}
